export default "__VITE_ASSET__DBoKhhiy__"